module.exports = __webpack_public_path__ + "img/Seite19.e6fdca78.png";